import { Button, Collection, Divider, Flex, Icon, Menu, MenuButton, MenuItem, Text, View } from '@aws-amplify/ui-react';
import { Grid, TextField } from '@mui/material';
import React from 'react'
import ReactMarkdown from 'react-markdown';
import "../App.css"
import generalagent from '../langchain/generalagent';
import GetImageUrl from './GetImageUrl';
import { PropagateLoader, SkewLoader } from 'react-spinners';
import Modal from 'react-modal'
import {motion} from 'framer-motion'
import ModalGeneralAgent from '../modals/ModalGeneralAgent';
import GoogleSearchModal from './GoogleSearchModal.tsx';
import { addProjectChat, deleteProjectChat, getProjectChats, getProjects } from '../apigateway/mongocalls.ts';
import { invokeGoogleSearchApi, invokeTTSAgentApi } from '../apigateway/agentcalls.ts';
import { useAuthStore } from 'store/index.ts';
import { Tilt } from 'react-tilt';
import getAuthusercreds from 'aws_utils/getAuthusercreds.js';
import StorageGet from 'aws_utils/s3storageget.js';
import ReactHowler from 'react-howler'

export default function QueryboxGeneralAgent(props) {

    const { authToken, refreshToken } = useAuthStore();
    const [query, setQuery] = React.useState("")
    const [isloading, setisloading] = React.useState(false)
    const [onHoverChat, setonHoverChat] = React.useState(false)
    const [deleteChatModel, setdeleteChatModel] = React.useState(false)
    const [chatIdToDelete, setchatIdToDelete] = React.useState('')
    const [hoverChatId, sethoverChatId] = React.useState('');  

      const [responseOptionsLoading, setresponseOptionsLoading] = React.useState(false)
      const [playing, setPlaying] = React.useState(false);
      const playerRef = React.useRef(null);
      const [ttsurl, setttsurl] = React.useState({id: "", loaded : false, ttsurl : ''})
      const [openMoveModal, setopenMoveModal] = React.useState(false);
      const [openCopyModal, setopenCopyModal] = React.useState(false)
      const [userProjects, setuserProjects] = React.useState([]);
      const [selectedProject, setselectedProject] = React.useState("");
      const [itemToMove, setitemToMove] =React.useState({});
      const [moveItemLoading, setmoveItemLoading] = React.useState(false);
      const [itemToCopy, setitemToCopy] = React.useState({})
      const [copyItemLoading, setcopyItemLoading] = React.useState(false)
       
      const closeMoveModal = () => {
            setopenMoveModal(false);
          }
      const closeCopyModal = () => {
            setopenCopyModal(false);
          }
      
      const restart = () => {
            if (playerRef.current) {
              playerRef.current.seek(0); // go to start (0 seconds)
              setPlaying(true);      
            }
          };
      
      const skip = (delta) => {
            if (playerRef.current) {
              const current = typeof playerRef.current.seek === 'function' ? playerRef.current.seek() : 0;
              const target = Math.max(0, current + delta);
              playerRef.current.seek(target);
              setPlaying(true);   
            } 
          };
      
      const handlePlay = () => {
          setPlaying(!playing);
          };
      
    
    




    const closeDeleteChatModal = () => {
          setdeleteChatModel(false);
        };

    React.useEffect(() => {
      if(isloading){
        setTimeout(() => {setisloading(false)}, 90000)
      }
    }, [isloading])
    
  
    const currentproject = props.projectname
    const [projectconversation, setprojectconversation] = React.useState([])

    const getUserProjects = async () => {
                // setgetUserProjectsLoading(true)
                const projects = await getProjects(authToken)
    
                 if(projects === 'refresh token'){
                                  const refreshResp = await refreshToken();
                                  if(refreshResp){
                                    const projects = await getProjects(refreshResp)
                                    setuserProjects(projects)
                                    return
                                  }
                                  return
                                }
    
                setuserProjects(projects)
                // setgetUserProjectsLoading(false)
      }

    const UserChat = async () => {
      if(authToken){
      const userschat = await getProjectChats(currentproject, authToken)


       // Refresh Token
            if(userschat === 'refresh token'){
              // console.log('refresh token from document agent...')
                const refreshResp = await refreshToken();
                if(refreshResp){
                const userschat = await getProjectChats(currentproject, refreshResp);
                const convo = userschat.filter(convo => convo.image !== true)
                setprojectconversation(convo.reverse())
                setisloading(false);
                setnewquery(false)
                return
                }
              return
            }

      const convo = userschat.filter(convo => convo.image !== true)
      setprojectconversation(convo.reverse())
      setisloading(false);
      setnewquery(false)
          }
      }

    React.useEffect(() => {
      if(currentproject === "" || currentproject === null || currentproject === undefined){
        return
      }
      setisloading(true);
      UserChat()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentproject, authToken])

    const [newquery, setnewquery] = React.useState(false)
    React.useEffect(() => {
      const refreshquerybox = async () => {
        if(newquery){
        UserChat()
        }
      }
      refreshquerybox()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newquery])
    

    const [googleFrame, setgoogleFrame] = React.useState([])
    React.useEffect(() => {
      setgoogleFrame([])
    }, [currentproject])
    
    const QueryGeneralAgent = async () => {
      if(currentproject === "" || currentproject === null || currentproject === undefined){
        setisloading(false);
        setnewquery(false);
        window.scrollTo(0,0);
        alert("Select or Create Project!")
        return
        }
        if(query === ""){
            
            setisloading(false)
            setnewquery(false)
            alert("Enter query!")
            return
        }
        await generalagent(query, currentproject, projectconversation)
        // const data = await invokegooglesearch(query)
        // const cleanJSON = JSON.parse(data)
        // setgoogleFrame(cleanJSON.body)
        const data = await invokeGoogleSearchApi(query)
        setgoogleFrame(data);
        setnewquery(true)
        // setisloading(false)
        setQuery(" ")
        window.scrollTo(0,document.body.scrollHeight);
        
    }

    const [showQueryBox, setShowQueryBox] = React.useState(false)
    const closeQueryBox = async () => {
        setShowQueryBox(false)
        UserChat()
    }


    const [searchModal, setSearchModal] = React.useState(false)
    const showGoogleSearch = () => {
      setSearchModal(true)
    }

    const closeSearchModal = () => {
      setSearchModal(false)
    }


  return (
    <View
        className="relative flex flex-col  pt-[30px] pb-[50px] w-full h-[80vh] "    
    // backgroundColor="pink"   
    >
      <View id={`Sa`} className="relative flex flex-col bg-[rgba(255,255,255,.3)]  w-full h-full  pl-3 pr-3 pb-3 rounded-3xl overflow-scroll">

    {/* Query texfield plus button */}
      <Flex
        // backgroundColor="green"
        width="100%"
        height="auto"
        justifyContent="center"
        alignItems="center"
        direction="column"
        paddingTop="20px"
        paddingBottom="20px"
        gap="10px"
        
        
        >
     
      <TextField
      sx={{
        color: 'white',
        
        // background: "red"
        
      
      }}
      // color='white' 
        position="relative"
        // className="border-red"
        
        // boxShadow="0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)"
        // backgroundColor="blue"
        
        // height="500px"
       multiline 
       fullWidth
       id="outlined-basic" 
       label="Enter Query ..." 
       variant="outlined" 
      //  className=' text-zinc-100 '
        // className='QueryInput'
        // top='-20px'
        value={query}
        onChange={(e) => {
            let { value } = e.target;
            setQuery(value);
          }}
        height="45px"
      />

<motion.div
        initial={{
            // width : "100%",
        }}
        whileHover={{
          scale : 1.1,
        //   paddingLeft : "25px"
        }}
        whileTap={{
          scale: 0.9,
          
        }}
        
        >
         <Button
         position="relative"
      height="30px"
      color="black"
      className='CollectionCard'
      variation='primary'
      isLoading={isloading}
      boxShadow="0px 5px 15px rgba(0, 0, 0, 0.10000000149011612)"
    //   isDisabled={dataloaded ? false : true}
    onClick={()=> {
       setisloading(true)
       QueryGeneralAgent()  
    }}
     
      >
        Query
         </Button>

         </motion.div>
    
      </Flex>
     {/* Query texfield plus button */}

     {/* Related link */}
      <Flex
     width="100%"
    //  backgroundColor="pink"
     >
     <motion.div
        initial={{
            // width : "100%",
        }}
        whileHover={{
          scale : 1.1,
          // paddingLeft : "2px"
        }}
        whileTap={{
          scale: 0.9,
          
        }}
        
        >
         <Text
         color="white"
         paddingLeft={5}
         fontWeight="bold"
         paddingBottom={5}
         
          
          onClick={async () => {
            if(googleFrame.length === 0){
            const data = await invokeGoogleSearchApi(currentproject);
            setgoogleFrame(data);
            } else {
            showGoogleSearch()
            }
            }}>
            Show Related Links!
          </Text>
          </motion.div>
      </Flex>
        {/* Related link */}
        
    {/* The query box itself */}
    
      <View
      className="relative overflow-x-scroll h-full"
    
        >
     
    

      {isloading ? 
        <Grid
        container
        display="flex"
        position="relative"
        justifyContent="center"
        alignItems='center'

        width="100%"
        height="100%"
       
        // paddingRight="50px"
        // paddingTop="40px"
        // backgroundColor="pink"
        >
          {/* <Flex
          justifyContent="flex-start"
          alignItems="center"
          position="relative"
          paddingRight="50px"
          width="50px"
          height="40px"
           marginBottom="50px"
          // backgroundColor="brown"
          > */}
          <SkewLoader
        loading="true"
        // color='#de8865cc'
        color='white'
        size="50px"
        /> 
          {/* </Flex> */}
        </Grid>
        : 
        
      // Collection of query and response
          <Collection
        items={projectconversation || []}
        type="list"
        direction="column"
        position="relative"
        searchNoResultsFound=" "
        overflow="hidden"
        searchPlaceholder="Search query"
        isSearchable
        isPaginated
        itemsPerPage={5}     
    >
      {(item, index) => (   
          <Flex
          position="relative"
          // backgroundColor="red"
          direction="column"
          gap="10px"
          paddingTop="0px"
          key={index}
          onMouseOver={() => {
            setonHoverChat(true)
            sethoverChatId(item._id)
            // console.log('hovering over', item._id);
          }}
          >

            {/* Chat Drop DOwn */}
            <View  display={onHoverChat && hoverChatId === item._id ? 'flex' : 'none'} className=" absolute z-50 flex justify-end w-full mt-[8px] pr-[10px]">
            {responseOptionsLoading ? 
                          
              <View className="absolute flex justify-center pl-12  w-full">
                        <View className='relative block w-[50px] h-[50px] '>
                          <SkewLoader
                            loading="true"
                            // color='#de8865cc'
                    
                            color='white'
                            size="20px"
                            /> 
                          </View>
              </View> :

                <Menu
                                        triggerClassName="my-menu-trigger"
                                        className="my-menu-content"
                                        // className=' bg-amber-600'
                                        menuAlign="end"
                                        width="200px"
                                        height="auto"
                                        sx={{
                                          zIndex: 9999
                                        }}
                                        display="block"
                                        gap="unset"
                                        alignItems="unset"
                                        justifyContent="unset"
                                        shrink="0"
                                        position="relative"
                                        padding="0px 0px 0px 0px"
                                        // marginTop="10px"
                                        trigger={
                                        <MenuButton
                                        className="my-menu-trigger"
                                        borderRadius='5px'
                                         >
                                            <Icon
                                          width="13.5px"
                                          height="6.66px"
                                          viewBox={{
                                            minX: 0,
                                            minY: 0,
                                            width: 13.5,
                                            height: 6.662109375,
                                          }}
                                          paths={[
                                            {
                                              d: "M0.21913 0.220211C0.511724 -0.0729808 0.986598 -0.0734649 1.27979 0.21913L5.01935 3.95108C5.4238 4.3547 5.69564 4.62517 5.92172 4.81672C6.14109 5.00259 6.26763 5.06987 6.36421 5.10121C6.61497 5.18257 6.88503 5.18257 7.13579 5.10121C7.23237 5.06987 7.35891 5.00259 7.57828 4.81672C7.80436 4.62517 8.0762 4.3547 8.48064 3.95108L12.2202 0.21913C12.5134 -0.0734649 12.9883 -0.0729808 13.2809 0.220211C13.5735 0.513402 13.573 0.988276 13.2798 1.28087L9.54022 5.01282L9.51868 5.03432C9.14132 5.41093 8.82631 5.72531 8.54795 5.96116C8.25761 6.20717 7.95825 6.41133 7.59873 6.52798C7.04707 6.70698 6.45293 6.70698 5.90127 6.52798C5.54175 6.41133 5.24239 6.20717 4.95204 5.96116C4.67368 5.7253 4.35866 5.41091 3.98129 5.03429L3.95978 5.01282L0.220211 1.28087C-0.0729808 0.988276 -0.0734649 0.513402 0.21913 0.220211Z",
                                              fill: "white",
                                              fillRule: "evenodd",
                                            },
                                          ]}
                                          display="block"
                                          gap="unset"
                                          alignItems="unset"
                                          justifyContent="unset"
                                          position="absolute"
                                        >
                                          
                                            </Icon>   
                                        </MenuButton>}
                                        /// Arrow next  to user.name
                                      >
                                        
                                       
                                        <Flex
                                        height='50px'
                                        // backgroundColor="red"
                                        >
                                        
                                        <Text
                                        marginTop="15px"
                                        marginLeft="18px"
                                        color="black"
                                        
                                        > 
                                        {"Response Options"}
                                        </Text>
                        
                                        </Flex>
                        
                                        <Divider />
                               
              <MenuItem
              width='100%'
              height='50px'
                onClick={async () => {
                  setresponseOptionsLoading(true);
                  setPlaying(false)
                  // console.log('item details', item);
                  
                  const qk = item._id;
                  const id = await getAuthusercreds();
                  const identityId = id.identityId;

                  // console.log('query key', qk);
                  // console.log('identity id', identityId);

                  
                  const fileName = `${currentproject} ${qk}.mp3`;
                  const mp3url = await StorageGet(fileName);
                  // console.log('mp3 url', mp3url)
                  if(mp3url !== false){
                    setttsurl({ id: item._id,loaded: true , ttsurl: mp3url});
                    setPlaying(true)
                    setresponseOptionsLoading(false);
                  }

                  if(mp3url === false){
                    // console.log('Generating audio...')
                  const ttsresp = await invokeTTSAgentApi(item.response, identityId, qk, currentproject);

                  if(ttsresp){
                    // console.log('retrieving audio...')
                    const fileName = `${currentproject} ${qk}.mp3`;
                    const mp3url = await StorageGet(fileName);
                    // console.log('mp3 url', mp3url)
                    // console.log("set audio...")
                    setttsurl({id: item._id, loaded: true , ttsurl: mp3url});
                    setPlaying(true);
                    setresponseOptionsLoading(false);
                    }

                     if(ttsresp === false){
                       setPlaying(false);
                       setresponseOptionsLoading(false);
                     }


                  }
                }}
               >
                {'Listen'}
              </MenuItem>

              <MenuItem
              width='100%'
              height='50px'
              className=" hover:text-white"
              onClick={async ()=>{
                 setselectedProject('');
                 setitemToMove(item);
                 setresponseOptionsLoading(true);
                 await getUserProjects();
                 setopenMoveModal(true)
                 setresponseOptionsLoading(false);
              }}
              
               >
                <Text
                // fontWeight="normal"     
                display="flex"
                // justifyContent="center"
                alignItems="center"
                className=" hover:text-white"
                width="100%"
                height="100%"
                // backgroundColor="red"
                
                >
               {`Move`}
                </Text>
              </MenuItem>
               
             
              <MenuItem
              width='100%'
              height='50px'
              className=" hover:text-white"
              onClick={async ()=>{
                // console.log('item', item)
                 setselectedProject('');
                 setitemToCopy(item);
                 setresponseOptionsLoading(true);
                 await getUserProjects();
                 setopenCopyModal(true)
                 setresponseOptionsLoading(false);
              }}
              
               >
                <Text
                // fontWeight="normal"
                display="flex"
                // justifyContent="center"
                alignItems="center"
                className=" hover:text-white"
                width="100%"
                height="100%"
                // backgroundColor="red"
                
                >
                  {`Copy`}
                </Text>
              </MenuItem>
                        
                          <MenuItem
                          width='100%'
                          height='50px'
                            onClick={() => {
                                      setchatIdToDelete(item._id)
                                      setdeleteChatModel(true);
                                    }}
                           >
                            {'Delete'}
                          </MenuItem>
            
                          
                                  
                </Menu>}


            </View>
          {/* Chat Drop DOwn */}  

          <Grid container
          position="relative"
          width="100%"
          // backgroundColor="rgba(255,255,255,.8)"
          // backgroundColor="rgba(222,136,101,.8)"
          backgroundColor="grey"
          boxShadow="0px 5px 15px rgba(0, 0, 0, 0.4)"
          padding="10px 10px 10px 10px"
          borderRadius="16px"
          direction="column"
          gap="5px"
          pb="15px"
          // className=' flex-wrap break-words whitespace-break-spaces text-ellipsis'
          //  wrap="wrap"
          //  whiteSpace="pre-wrap"
          sx={{
            textOverflow:"ellipsis",
            wordWrap: "break-word",
            overflowWrap: "anywhere",
            flexWrap: "wrap",
            whiteSpace:"break-spaces",
            lineBreak: "strict",
            
          }}
          >
          <Text
         
          // backgroundColor="pink"
          color="white"
          >
          Query: 
          </Text>

          <ReactMarkdown
          className={"text-white mr-5 ml-5"}
          components={{
           
            code({node, inline, className, children, ...props}) {
              const match = /language-(\w)/.exec(className || "")
              return !inline && match ? ( 
             
                <Grid container
              position="relative"
              paddingLeft="20px"
              paddingRight="20px"
              fontSize="15px"
              fontWeight="bold"
                  width="auto"
                
                  // className=' flex-wrap break-words whitespace-break-spaces text-ellipsis'
                  // wrap="wrap"
                  // whiteSpace="pre-wrap"
                  
                   sx={{
          
            textOverflow:"ellipsis",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            flexWrap: "wrap",
            whiteSpace: "break-spaces",
            lineBreak: "anywhere"
                 }}
                 {... props}>
                  
                  {children}
                  
                </Grid> 
            
                ) : (
                 <Grid container
              position="relative"
              paddingLeft="20px"
              paddingRight="20px"
              fontSize="15px"
              width="auto"
             
                  className='font-extrabold '
                  
                   sx={{
            textOverflow:"ellipsis",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "break-spaces",
            lineBreak:"anywhere"
          }}
                 {... props}>
                  
                  {children}
                  
                </Grid> )
            }
          }}
          children={item.query}

          >
            
          
         {/* {item.query} */}
          
          
        
         
          </ReactMarkdown>
          
           {item?.images ? <GetImageUrl img={item.images || []}/> : <></>}
                    
                   
          </Grid>

          <Grid container
          position="relative"
          width="100%"
          // display="flex"
          // justifyContent="flex-start"
          // backgroundColor="rgba(222,136,101,.9)"
          backgroundColor="rgba(255,255,255,.6)"
          boxShadow="0px 5px 15px rgba(0, 0, 0, 0.4)"
          padding="10px 10px 10px 10px"
          borderRadius="16px"
          // overflow="scroll"
          direction="column"
          pb="20px"
            sx={{
            textOverflow:"ellipsis",
            wordWrap: "break-word",
            overflowWrap: "anywhere",
            flexWrap: "wrap",
            whiteSpace:"break-spaces",
            lineBreak: "strict",
            // lineBreak: "anywhere",

            // textOverflow:"ellipsis",
            // wordWrap: "break-word",
            // overflowWrap: "anywhere",
            // wordBreak: "break-word",
            // flexWrap: "wrap",
            
            
          }}
          gap="5px"
          >
            {/* Restart Play Back Forward */}
                        <View key={index}  display={onHoverChat && hoverChatId === item._id && ttsurl.id === item._id ? 'flex' : 'none'} className="relative  flex justify-end w-[100%] pr-1  ">          
                                          
                                          {ttsurl.loaded && ttsurl.id === item._id ? 
                                          
                                          <View className="relative flex  gap-2 flex-wrap w-full justify-end ">
                                            
                                              <ReactHowler  
                                                ref={playerRef}
                                                // onEnd={setPlaying(false)}
                                              
                                              onLoadError={() => {
                                                setttsurl({
                                                  id: "",
                                                  loaded: false,
                                                  ttsurl: ""
                                                })
                                                // console.log('load error')
                                              }}
                      
                                                src={ttsurl.ttsurl} // Add your audio file here
                                                playing={playing}
                                                
                                                />
                                                <Button color="white" backgroundColor="gray"  border="transparent"    height="32px"
                                                fontSize="small"
                                                fontWeight="medium"
                                                textAlign="center"
                                                className='SignInUp' onClick={() => {
                                                  skip(-10)
                                                }}>
                                                {'Back'}
                                                </Button>
                      
                                                <Button color="white" backgroundColor="gray"  border="transparent"    height="32px" 
                                                fontSize="small"
                                                fontWeight="medium"
                                                textAlign="center"className='SignInUp' onClick={() => {
                                                  skip(+10)
                                                }}>
                                                {'Forward'}
                                                </Button>
                      
                                                <Button color="white" backgroundColor="gray"  border="transparent"    height="32px" 
                                                fontSize="small"
                                                fontWeight="medium"
                                                textAlign="center"className='SignInUp' onClick={restart}>
                                                {'Restart'}
                                                </Button>
                      
                                                <Button color="white" backgroundColor="gray"  border="transparent"   height="32px" 
                                                fontSize="small"
                                                fontWeight="medium"
                                                textAlign="center"className='SignInUp' onClick={handlePlay}>
                                                {playing ? 'Pause' : 'Play'}
                                              </Button>
                                    
                                          </View> : <></>}
                                      
                        </View>
                        {/* Restart Play Back Forward */}
                      
            
          <Text
          color="black"
          // backgroundColor="pink"
          >
          Response: 
          </Text>

         
      
          
          {/* {rm.render(item.response)} */}
          
     
          <ReactMarkdown
          className="mr-5 ml-5"
          components={{
           
            code({node, inline, className, children, ...props}) {
              const match = /language-(\w)/.exec(className || "")
              return !inline && match ? ( 
             
                <Grid container
              position="relative"
              paddingLeft="20px"
              paddingRight="20px"
              fontSize="15px"
              fontWeight="bold"
                  width="auto"
                  wrap="wrap"
                  whiteSpace="pre-wrap"
                  // wrap="wrap"
                  // whiteSpace="pre-wrap"
                  
                  sx={{
            // textOverflow:"ellipsis",
            // wordWrap: "break-word",
            // overflowWrap: "break-word",
            // flexWrap: "wrap",
            // whiteSpace: "break-spaces",
            wordWrap: "break-word",
            overflowWrap: "anywhere"
        
          
          }}
                  
               
                  
                 {... props}>
                

                 
                  {children}
                  
                </Grid> 
            
                ) : 
            
                 <Grid container
              position="relative"
              paddingLeft="20px"
              paddingRight="20px"
              fontSize="15px"
              width="auto"
             
                  className='font-extrabold '
                  
                   sx={{
            textOverflow:"ellipsis",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "break-spaces",
            lineBreak:"anywhere"
          }}
                 {... props}>
                  
                  {children}
                  
                </Grid>
              //  <span
              //   className=' font-extrabold flex-wrap break-words whitespace-break-spaces text-ellipsis'
                
              //   // position="relative"
              //   >
              //     {children}

              //   </span>


            }
          }}
          children={item.response}
        
          />
          
            
          
          
          
          
        
         
       
          
          </Grid>

          </Flex>
      )}
          </Collection>
        
}
      </View>
      
    {/* The query box itself */}
      </View>
      
    <Modal
    isOpen={showQueryBox}
    onRequestClose={closeQueryBox}
    style={{
      overlay: {
        position: 'fixed',
        display: 'flex',
        justifyContent: 'flex-start',
      //   alignItems: 'center',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255,255,255,.8)',
        zIndex: 9999,
        paddingLeft: "20px",
        overflow: "scroll",
        paddingTop: "20px",
        paddingBottom: "10px",
        paddingRight: "20px"
      },
      content: {
        position: 'relative',
        display: "block",
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        border: '3px solid grey',
      //   minHeight: "auto",
        maxHeight: "95vh",
        minHeight: "auto",
        // background: 'rgba(222,136,101,.95)',
        background: "grey",
        width: "100%",
      //   overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '15px',
        outline: 'none',
        paddingTop: "0px",
        paddingBottom: "10px",
        paddingLeft: "20px",
        paddingRight: "20px"


      }
    }}
  
    
    >
        
        {/* <Text
        width="100%"
        textAlign="center"
        backgroundColor="red"
        >
            Image Agent
        </Text> */}

       <ModalGeneralAgent 
       projectname={currentproject}
       closeQueryBox={closeQueryBox}
       />

    </Modal>  

{/* Move Chat Modal */}
    <Modal
         isOpen={openMoveModal}
         onRequestClose={closeMoveModal}
         style={{
             overlay: {
             position: 'fixed',
             display: 'flex',
             justifyContent: 'center',
             alignItems: 'center',
             top: 0,
             left: 0,
             right: 0,
             bottom: 0,
             backgroundColor: 'rgba(255, 255, 255, 0.75)',
             zIndex: 999,
             },
             content: {
             position: 'relative',
     //   display
             top: '0px',
             left: '0px',
             right: '0px',
             bottom: '0px',
             border: '0px solid #ccc',
             
            background: "gray",
            width: '80%', 
             WebkitOverflowScrolling: 'touch',
             borderRadius: '20px',
             outline: 'none',
             padding: '0px'
             }
         }}
         >

          <Flex
           position="relative"
           justifyContent="start"
           direction="column"
           padding="30px 30px 30px 30px"
          //  gap="15px"
          //  backgroundColor="pink"
          //  alignItems="center"
          //  direction="column"
          //  textAlign="center"
          //  width="300px"
          //  height="200px"  
           >

             <Text
              position="relative"
              color="white"
              fontSize="20px"
              fontWeight="bold"
              width="100%"
              textAlign="start"
              // backgroundColor="red"
              
            >
           
             Move chat response from current project to another project. Note: Will delete chat from current project on move.
          
             
             

            </Text>

            <Text
              position="relative"
              color="white"
              fontSize="20px"
              fontWeight="bold"
              width="100%"
              // backgroundColor="red"
              
            >
           
             Select what project you want to move chat to?
          
             
             

            </Text>

            <Text
              position="relative"
              color="white"
              fontSize="30px"
              fontWeight="medium"
              width="100%"
              // backgroundColor="red"
              
            >
           
             Project selected: {selectedProject ? `"${selectedProject}"` : 'No Project Selected'}
          
             
             

            </Text>

            <Collection
            items={userProjects || []}
            type="list"
            // templateColumns="1fr 1fr"
            // templateRows="12rem 12rem"
            direction="row"
            // display="none"
            justifyContent="flex-start"
            // justifyContent="center"
            

            className='Collection'
            alignItems="center"
          
            searchPlaceholder={` `}
            searchNoResultsFound={
                <Flex justifyContent="center"
                paddingBottom="20px"
                >
                  <Text fontSize="2rem"
                  color="white"
                  textAlign="center"
                  >
                    {`No Projects Created`}
                  </Text>
                </Flex>
              }
            width="100%"
            // height="100px"
            columnGap="15px"
            isSearchable
            paddingLeft="20px"
            textAlign="center"
            paddingRight="20px"
            // wrap="nowrap"
            paddingTop="15px"
            paddingBottom="20px"
            // color="white"
            // backgroundColor="pink"
            overflow="scroll"
            
            isPaginated 
                itemsPerPage={7}  
            >

              {(item, index) => (   

        
                <Tilt
                  key={index}
                  >
              
          
                    <View
                      display="flex"
                      variation="primary"
                      height="auto"
                      justifyContent="center"
                      alignItems="center"
                      position="relative"
                      boxShadow="0px 5px 15px rgba(0, 0, 0, .4"
                      borderRadius="16px"
                      // backgroundColor="rgba(222,136,101,.8)"
                      // backgroundColor="rgba(225,255,255,.3)"
                      backgroundColor="rgba(255,255,255,.5)"
                      direction="column"

                      // paddingBottom="20px"
                      // paddingTop="20px"
                      className="w-[140px]"
                      onClick={()=>{
                          setselectedProject(item.projectname)
                
                        }}
                      >
              
                    <Flex
                      position="relative"
                      backgroundColor="green"  
                      width="100%"
                      justifyContent="flex-end"
                      // paddingRight="10px"
                    >
                    </Flex>

                    <Text
                      textDecoration="none"
                      variation="primary"
                      position="relative"
                      fontSize="15px"
                      display="flex"
                      fontWeight="bold"
                      width="100px"
                      height="120px"
                      justifyContent="center"
                      alignItems="center"
                      color="white"
            
                    >
                        {item.projectname} 
                    </Text>
    
        
                    </View>

         

                </Tilt>
        
        
                )}

             

            </Collection>   
        
             
        
            {/* Yes / No */}
            {selectedProject ? 
              
            <>
            {moveItemLoading ? 
            <><View className="relative flex justify-center w-full pt-8 pl-10">
          <View className='relative block w-[50px] h-[50px] '>
            <PropagateLoader
              loading="true"
              // color='#de8865cc'
      
              color='white'
              size="20px"
              /> 
            </View>
            </View></> : <Flex
              width="100%"
              // backgroundColor="pink"
              position="relative"
              display="flex"
              // wrap="nowrap"
              gap="20px"
              direction="column"
              height="auto"
              justifyContent="center"
              paddingTop="5px"
              >
                <Text
              position="relative"
              color="white"
              fontSize="20px"
              fontWeight="extrabold"
              width="100%"
              textAlign="center"
              // backgroundColor="red"
              
            >
           
             Are you sure you want to move chat to project "{selectedProject}"?
            </Text>

              <View className="relative flex justify-center w-full  gap-5">

              <motion.button
              whileHover={{scale : 1.2}}
              whileTap={{scale: 0.9}}
              onClick={async () => {

                setmoveItemLoading(true);
                const moving = itemToMove;
                // console.log('Moving this item', moving);
                
                const moveChatPackage = {
                    project: selectedProject,
                    userId: moving.userId,
                    query: moving.query,
                    response: moving.response,
                    agent: moving.agent,
                  // image?: boolean,
                  // images?: any,
                  // image_url?: any,
                }
                const addchatres = await addProjectChat(moveChatPackage);
                if(addchatres){
                  alert(`Successfully moved chat to "${selectedProject}" project.`)
                await deleteProjectChat(moving._id)  
                setnewquery(true);
                setmoveItemLoading(false);
                setopenMoveModal(false);
                }
              

               }}
     
              >    
              <Text
              
              color="white"
              backgroundColor="rgba(255,255,255,.5)"  
              display="flex"           
              height="35px"
              width="45px"
              justifyContent="center"
              alignItems="center"
              //  textAlign="center"
              borderRadius="5px"
              fontWeight="bold"
              className='relative cursor-pointer'
              
              >
                Yes
              </Text>
              </motion.button>
              <motion.button
                whileHover={{scale : 1.2}}
                whileTap={{scale: 0.9}}
                onClick={() => {
                  setselectedProject('')
                }}
                //  onClick={closeDeleteChatModal}
                >
                <Text
                color="white"
                backgroundColor="rgba(255,255,255,.5)"
                display="flex"           
                height="35px"
                width="45px"
                justifyContent="center"
                alignItems="center"
                //  textAlign="center"
                borderRadius="5px"
                fontWeight="bold"
                className='cursor-pointer'
                >
                  No
                </Text>
              </motion.button>
              </View>

            </Flex> }
            
            
            </>
            
            : 
            
            <></>
            
            }
            
            {/* Yes / No */}
         
         
           </Flex>
           
         
    </Modal>  
    {/* Move Chat Modal */}

    {/* Copy Chat Modal */}
    <Modal
         isOpen={openCopyModal}
         onRequestClose={closeCopyModal}
         style={{
             overlay: {
             position: 'fixed',
             display: 'flex',
             justifyContent: 'center',
             alignItems: 'center',
             top: 0,
             left: 0,
             right: 0,
             bottom: 0,
             backgroundColor: 'rgba(255, 255, 255, 0.75)',
             zIndex: 999,
             },
             content: {
             position: 'relative',
     //   display
             top: '0px',
             left: '0px',
             right: '0px',
             bottom: '0px',
             border: '0px solid #ccc',
             
            background: "gray",
            width: '80%', 
             WebkitOverflowScrolling: 'touch',
             borderRadius: '20px',
             outline: 'none',
             padding: '0px'
             }
         }}
         >

          <Flex
           position="relative"
           justifyContent="start"
           direction="column"
           padding="30px 30px 30px 30px"
          //  gap="15px"
          //  backgroundColor="pink"
          //  alignItems="center"
          //  direction="column"
          //  textAlign="center"
          //  width="300px"
          //  height="200px"  
           >

            <Text
              position="relative"
              color="white"
              fontSize="20px"
              fontWeight="bold"
              width="100%"
              // backgroundColor="red"
              
            >
           
             Select what project you want to copy chat to?
          
             
             

            </Text>

            <Text
              position="relative"
              color="white"
              fontSize="30px"
              fontWeight="medium"
              width="100%"
              // backgroundColor="red"
              
            >
           
             Project selected: {selectedProject ? `"${selectedProject}"` : 'No Project Selected'}
          
             
             

            </Text>

            <Collection
            items={userProjects || []}
            type="list"
            // templateColumns="1fr 1fr"
            // templateRows="12rem 12rem"
            direction="row"
            // display="none"
            justifyContent="flex-start"
            // justifyContent="center"
            

            className='Collection'
            alignItems="center"
          
            searchPlaceholder={` `}
            searchNoResultsFound={
                <Flex justifyContent="center"
                paddingBottom="20px"
                >
                  <Text fontSize="2rem"
                  color="white"
                  textAlign="center"
                  >
                    {`No Projects Created`}
                  </Text>
                </Flex>
              }
            width="100%"
            // height="100px"
            columnGap="15px"
            isSearchable
            paddingLeft="20px"
            textAlign="center"
            paddingRight="20px"
            // wrap="nowrap"
            paddingTop="15px"
            paddingBottom="20px"
            // color="white"
            // backgroundColor="pink"
            overflow="scroll"
            
            isPaginated 
                itemsPerPage={7}  
            >

              {(item, index) => (   

        
                <Tilt
                  key={index}
                  >
              
          
                    <View
                      display="flex"
                      variation="primary"
                      height="auto"
                      justifyContent="center"
                      alignItems="center"
                      position="relative"
                      boxShadow="0px 5px 15px rgba(0, 0, 0, .4"
                      borderRadius="16px"
                      // backgroundColor="rgba(222,136,101,.8)"
                      // backgroundColor="rgba(225,255,255,.3)"
                      backgroundColor="rgba(255,255,255,.5)"
                      direction="column"

                      // paddingBottom="20px"
                      // paddingTop="20px"
                      className="w-[140px]"
                      onClick={()=>{
                          setselectedProject(item.projectname)
                
                        }}
                      >
              
                    <Flex
                      position="relative"
                      backgroundColor="green"  
                      width="100%"
                      justifyContent="flex-end"
                      // paddingRight="10px"
                    >
                    </Flex>

                    <Text
                      textDecoration="none"
                      variation="primary"
                      position="relative"
                      fontSize="15px"
                      display="flex"
                      fontWeight="bold"
                      width="100px"
                      height="120px"
                      justifyContent="center"
                      alignItems="center"
                      color="white"
            
                    >
                        {item.projectname} 
                    </Text>
    
        
                    </View>

         

                </Tilt>
        
        
                )}

             

            </Collection>   
        
             
        
            {/* Yes / No */}
            {selectedProject ? 
              
            <>
            {copyItemLoading ? 
            <><View className="relative flex justify-center w-full pt-8 pl-10">
          <View className='relative block w-[50px] h-[50px] '>
            <PropagateLoader
              loading="true"
              // color='#de8865cc'
      
              color='white'
              size="20px"
              /> 
            </View>
            </View></> : <Flex
              width="100%"
              // backgroundColor="pink"
              position="relative"
              display="flex"
              // wrap="nowrap"
              gap="20px"
              direction="column"
              height="auto"
              justifyContent="center"
              paddingTop="5px"
              >
                <Text
              position="relative"
              color="white"
              fontSize="20px"
              fontWeight="extrabold"
              width="100%"
              textAlign="center"
              // backgroundColor="red"
              
            >
           
             Are you sure you want to copy chat to project "{selectedProject}"?
            </Text>

              <View className="relative flex justify-center w-full  gap-5">

              <motion.button
              whileHover={{scale : 1.2}}
              whileTap={{scale: 0.9}}
              onClick={async () => {

                setcopyItemLoading(true);
                const moving = itemToCopy;
                // console.log('Copy this item', moving);
                
                const copyChatPackage = {
                    project: selectedProject,
                    userId: moving.userId,
                    query: moving.query,
                    response: moving.response,
                    agent: moving.agent,
                  // image?: boolean,
                  // images?: any,
                  // image_url?: any,
                }
                await addProjectChat(copyChatPackage);
                // setnewquery(true);
                alert(`Successfully copied chat to "${selectedProject}"`)   
                setcopyItemLoading(false);
                setopenCopyModal(false);
              

               }}
     
              >    
              <Text
              
              color="white"
              backgroundColor="rgba(255,255,255,.5)"  
              display="flex"           
              height="35px"
              width="45px"
              justifyContent="center"
              alignItems="center"
              //  textAlign="center"
              borderRadius="5px"
              fontWeight="bold"
              className='relative cursor-pointer'
              
              >
                Yes
              </Text>
              </motion.button>
              <motion.button
                whileHover={{scale : 1.2}}
                whileTap={{scale: 0.9}}
                onClick={() => {
                  setselectedProject('')
                }}
                //  onClick={closeDeleteChatModal}
                >
                <Text
                color="white"
                backgroundColor="rgba(255,255,255,.5)"
                display="flex"           
                height="35px"
                width="45px"
                justifyContent="center"
                alignItems="center"
                //  textAlign="center"
                borderRadius="5px"
                fontWeight="bold"
                className='cursor-pointer'
                >
                  No
                </Text>
              </motion.button>
              </View>

            </Flex> }
            
            
            </>
            
            : 
            
            <></>
            
            }
            
            {/* Yes / No */}
         
         
           </Flex>
           
         
    </Modal> 
    {/* Copy Chat Modal */}


    <Modal
    isOpen={searchModal}
    onRequestClose={closeSearchModal}
    style={{
      overlay: {
        position: 'fixed',
        display: 'flex',
        justifyContent: 'flex-start',
      //   alignItems: 'center',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255,255,255,.8)',
        zIndex: 9999,
        paddingLeft: "20px",
        overflow: "scroll",
        paddingTop: "20px",
        paddingBottom: "10px",
        paddingRight: "20px"
      },
      content: {
        position: 'relative',
        display: "flex",
        justifyContent: "flex-start",
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        border: '0px solid grey',
        height: "500px",

        // minHeight: "auto",
        // maxHeight: "95vh",
        // minHeight: "auto",
        background: 'grey',
        width: "auto",
        overflow: 'hidden',
        
        // WebkitOverflowScrolling: 'touch',
        borderRadius: '15px',
        outline: 'none',
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px"


      }
    }}
  
    
    >
      <GoogleSearchModal 
      googleFrame={googleFrame}/>
    </Modal>
    <Modal
             isOpen={deleteChatModel}
             onRequestClose={closeDeleteChatModal}
             style={{
                 overlay: {
                 position: 'fixed',
                 display: 'flex',
                 justifyContent: 'center',
                 alignItems: 'center',
                 top: 0,
                 left: 0,
                 right: 0,
                 bottom: 0,
                 backgroundColor: 'rgba(255, 255, 255, 0.75)',
                 zIndex: 999,
                 },
                 content: {
                 position: 'relative',
         //   display
                 top: '0px',
                 left: '0px',
                 right: '0px',
                 bottom: '0px',
                 border: '0px solid #ccc',
                 
           background: "gray",
         //   width: "302px",
         //   overflow: 'auto',
                 WebkitOverflowScrolling: 'touch',
                 borderRadius: '20px',
                 outline: 'none',
                 padding: '0px'
                 }
             }}
             >
    
    <Flex
               position="relative"
               justifyContent="center"
               alignItems="center"
               direction="column"
               textAlign="center"
               width="300px"
               height="200px"
              
               >
            
             <Text
             position="relative"
             color="white"
             fontSize="20px"
             fontWeight="extrabold"
             
             >
               
                 Are you sure you want to delete this Chat?
              
                 
                 
    
             </Text>
             <Flex
             width="100%"
             // backgroundColor="pink"
             position="relative"
             wrap="nowrap"
             gap="50px"
             height="auto"
             justifyContent="center"
             paddingTop="5px"
             >
                <motion.button
         whileHover={{scale : 1.2}}
         whileTap={{scale: 0.9}}
         onClick={ async () => {
    
       
       
         setisloading(true);   
         closeDeleteChatModal();
         const response = await deleteProjectChat(chatIdToDelete);
         if(response){
          setnewquery(true);
         } else {
          setisloading(false)
         }
         
         
    
        //  window.scrollTo(0,0)
      
        }}
         
         >
               <Text
               
               color="white"
               backgroundColor="rgba(255,255,255,.5)"  
               display="flex"           
               height="35px"
               width="45px"
               justifyContent="center"
               alignItems="center"
              //  textAlign="center"
               borderRadius="5px"
               fontWeight="bold"
               className='relative cursor-pointer'
               
               >
                 Yes
               </Text>
               </motion.button>
               <motion.button
         whileHover={{scale : 1.2}}
         whileTap={{scale: 0.9}}
         onClick={closeDeleteChatModal}
         >
               <Text
               color="white"
               backgroundColor="rgba(255,255,255,.5)"
               display="flex"           
               height="35px"
               width="45px"
               justifyContent="center"
               alignItems="center"
              //  textAlign="center"
               borderRadius="5px"
               fontWeight="bold"
               className='cursor-pointer'
               >
                 No
               </Text>
               </motion.button>
             </Flex>
             
             
               </Flex>
               
             
    </Modal>  
   
     </View>
  )
}
